import { render } from "./FailureBanner.vue?vue&type=template&id=35a48c9a&ts=true"
import script from "./FailureBanner.vue?vue&type=script&lang=ts"
export * from "./FailureBanner.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./FailureBanner.vue?vue&type=style&index=0&id=35a48c9a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__